(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('hyperapp')) :
	typeof define === 'function' && define.amd ? define(['hyperapp'], factory) :
	(global.nestable = factory(global.hyperapp));
}(this, (function (hyperapp) { 'use strict';

function nestable (state, actions, view, tagname) {
    actions._$r = function () {return {}};
    return function (props, children) {
        return hyperapp.h(tagname || 'x-', {
            key: props.key,
            id: props.id,
            class: props.class,
            oncreate: function (el) {
                var wired = hyperapp.app(
                    state,
                    actions,
                    function (s, a) {
                        var v = view(s, a);
                        if (typeof v === 'function') v = v(el._$p, el._$c);
                        return v
                    },
                    el
                );
                el._$p = props;
                el._$c = children;
                el._$r = wired._$r;
                el._$u = wired.uninit;
                wired.init && wired.init(props);
                props.oncreate && props.oncreate(el);
            },
            onupdate: function (el) {
                el._$p = props;
                el._$c = children;
                el._$r();
                props.onupdate && props.onupdate(el);
            },
            ondestroy: function (el) {
                el._$u && el._$u();
            },
            onremove: function (el, done) {
               if (!props.onremove) return done()

               props.onremove(el, done);
            }
        })
    }    
}

return nestable;

})));
//# sourceMappingURL=hyperapp-nestable.js.map
